"use client";

export { NotFound as default } from "~/features/error";
